import React, { Component } from 'react'
import { connect } from 'react-redux'
import { FormInput, ProjectListHeader } from '../../../components'
import { back, push } from '../../../actions/nav-actions'
import { fetchGoalsAndActivities, putGoalsAndActivities } from '../../../api';
import { notify, getDictionary } from '../../../utils'

class EvaluateContext extends Component {
  state = {
    project: {},
    is_loading: false,
    error: undefined,
    data: {}
  }
  constructor(props) {
    super(props);
    this.request = this.request.bind(this);
    this.getParams = this.getParams.bind(this);
    this.getRelationsByGoal = this.getRelationsByGoal.bind(this);
    this.client = getDictionary(props.dictionary);
    this.getText = this.getText.bind(this);
  }
  getText(tag, category = 'goals_and_activities') {
    return this.client.get(category, tag);
  }
  getParams() {
    return this.props.match.params || {};
  }
  getRelationsByGoal(goal = '') {
    let { relations } = this.state;
    return relations.filter(r => r.goal._id === goal);
  }
  componentDidMount() {
    const params = this.getParams();
    this.setState({ is_loading: true, error: undefined }, () => {
      fetchGoalsAndActivities(this.props.user.token,
        params.organization,
        params.code
      )
        .then((data) => {

          let selected_activities = data.options.goals.reduce((acc, goal) => {
            acc[goal._id] = data.relations.filter(r => r.goal._id === goal._id).map(r => r.activity._id);
            return { ...acc };
          }, {})

          this.setState({ is_loading: false, data, selected_activities, relations: data.relations });
        })
        .catch(err => this.setState({ is_loading: false, error: err }))
    });
  }
  request() {
    const params = this.getParams();
    putGoalsAndActivities(
      this.props.user.token,
      params.organization,
      params.code,
      {
        ...this.state.data,
        relations: this.state.relations
      }
    )
      .then((data) => notify("Update informations", "Successfully updated!"))
      .catch((err) => notify('Error', err.message, 'error'))
  }
  render() {
    if (this.state.error) return <span>{this.state.error.message}</span>
    if (!this.state.data.relations || this.state.is_loading) return <span>Loading data...</span>
    let { options, toc } = this.state.data;
    let latest_version_if, latest_version_and, latest_version_then, latest_version_because;
    if (toc) {
      latest_version_if = toc.questions.latest_version_if.sort((a, b) => a.uid < b.uid)[0];
      latest_version_and = toc.questions.latest_version_and.sort((a, b) => a.uid < b.uid)[0];
      latest_version_then = toc.questions.latest_version_then.sort((a, b) => a.uid < b.uid)[0];
      latest_version_because = toc.questions.latest_version_because.sort((a, b) => a.uid < b.uid)[0];
    }
    return (
      <React.Fragment>
        <div>
          <p>This is your latest version of your Theory of Change</p>
          {
            toc &&
            <p>
              (
                IF {latest_version_if ? latest_version_if.answer : "[empty]"} AND {latest_version_and ? latest_version_and.answer : "[empty]"} THEN {latest_version_then ? latest_version_then.answer : "[empty]"} BECAUSE {latest_version_because ? latest_version_because.answer : "[empty]"}
              ).
              </p>
          }
          <p>{this.getText('description')}</p>
        </div>

        <div>
          <ProjectListHeader title="GOALS AND SUBGOALS" />
          <div>
            {options.goals.map((goal, index) => {
              let { selected_goal } = this.state;
              let style = "text-muted";
              if (selected_goal === goal._id) style = "text-info";
              return (
                <a
                  href="#!"
                  onClick={(event) => {
                    event.preventDefault();
                    this.setState({ selected_goal: goal._id });
                  }}
                  key={index}>
                  <p className={style}>{goal.name}</p>
                </a>
              )
            })}
            <a
              href="#!"
              onClick={(event) => {
                event.preventDefault();
              }}>
              <p>Edit goals</p>
            </a>
          </div>
        </div>

        <div>
          <ProjectListHeader title="ACTIVITIES" />
          <div>
            {options.activities.map((activity, index) => {

              let selected_activities = this.state.selected_activities[this.state.selected_goal];
              if (!selected_activities) selected_activities = [];
              let is_selected = (selected_activities.indexOf(activity._id) !== -1);
              let style = "text-muted";
              if (is_selected) style = "text-info";

              return (
                <a
                  href="#!"
                  onClick={(event) => {
                    event.preventDefault();
                    if (!this.state.selected_goal) return;
                    let { selected_activities, relations } = this.state;

                    let data = selected_activities[this.state.selected_goal] || [];

                    if (data.indexOf(activity._id) !== -1) {
                      data = data.filter(a => a !== activity._id);
                      relations = relations.filter(r =>
                        (r.activity._id !== activity._id) &&
                        (r.goal._id !== activity.goal)
                      )
                    } else {
                      data = data.concat([activity._id]);
                      let goal = this.state.data.options.goals.filter(g => g._id === this.state.selected_goal)[0];
                      relations = relations.concat([
                        {
                          relation: "",
                          goal: {
                            _id: goal._id,
                            name: goal.name
                          },
                          activity: {
                            _id: activity._id,
                            name: activity.name
                          }
                        }
                      ])
                    }

                    selected_activities[this.state.selected_goal] = data;

                    this.setState({ selected_activities, relations });
                  }}
                  key={index}>
                  <p className={style}>{activity.name}</p>
                </a>
              )
            })}
          </div>
          <a
            href="#!"
            onClick={(event) => {
              event.preventDefault();
            }}>
            <p>Edit activities</p>
          </a>
        </div>

        <div>
          {options.goals.map((goal, index) => {
            return (
              <div key={index}>
                <ProjectListHeader title={goal.name} />
                <div>
                  <p>How do you relate this goal with:</p>
                  {this.getRelationsByGoal(goal._id).length === 0 &&
                    <p style={{ marginTop: 6 }}>No relations to this goal</p>
                  }

                  {this.getRelationsByGoal(goal._id).map((relation, gindex) => {
                    let position = this.state.relations.indexOf(relation);
                    return (
                      <div key={gindex}>
                        <p>{relation.activity.name}</p>
                        <FormInput
                          value={relation.relation}
                          onChange={(text) => {
                            let { relations } = this.state;
                            relations[position].relation = text;
                            this.setState({ relations });
                          }}

                          placeholder="" />
                      </div>
                    )
                  })}

                </div>
              </div>
            );
          })}

        </div>

        <button
          className="btn btn-info"
          onClick={this.request.bind(this)}
          style={{ marginTop: 24, marginBottom: 24 }}>
          SAVE
        </button>
      </React.Fragment>
    )
  }
}

const mapStateToProps = state => ({ ...state.localStorage, user: state.authReducer.user });

const mapDispatchToProps = dispatch => ({
  back() {
    dispatch(back())
  },
  push(routeName) {
    dispatch(push(routeName))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(EvaluateContext);


// WEBPACK FOOTER //
// ./src/routers/Projects/Formularies/GaAFormularies.js